<template>
  <div>

 <!-- Modal MESSAGE -->  
    <modalMessage ref="msgModal"/>


    <h4>GESTIONE ATTRIBUTI</h4>

     <!-- Creazione nuovo attributo -->
    <div class="form-inline">     
    <div class="form-group mx-sm-4 mb-2">

      <label>CREA NUOVO ATTRIBUTO</label>
      <input
        type="text"
        v-model="newAttributeName"
        class="form-control ml-3"
        placeholder="Nome attributo..."
        v-focus
      />
      <button
        class="btn btn-primary ml-3"
        :disabled="!newAttributeName"
        @click="addNewAttribute"
      >
        CREA ATTRIBUTO
      </button>
    </div>
    </div>

    <!-- Selezione attributo esistente -->
     <div class="d-flex justify-content-start">

    
    <div class="form-group">
      <label>SELEZIONA ATTRIBUTO ESISTENTE</label>
      <select v-model="selectedExistingAttributeId" class="form-control">
        <option value="" disabled>Seleziona attributo...</option>
        <option
          v-for="attr in availableAttributes"
          :key="attr.id"
          :value="attr.id"
        >
          {{ attr.attributo }}
        </option>
      </select>
      <button
        class="btn btn-success mt-2"
        :disabled="!selectedExistingAttributeId"
        @click="addExistingAttribute"
      >
        ASSOCIA ATTRIBUTO AL PRODOTTO
      </button>
    </div>
    </div>

    <!-- Attributi aggiunti al prodotto -->
    
    <div 
      v-for="(attrObj, index) in productAttributes"
      :key="attrObj.attribute.id"
      class="form-group border p-3 mb-3 w-50"
    >
      <div class="d-flex justify-content-between align-items-center mb-2">
        
            <div class="d-flex align-items-center">

                    <button
          class="btn-outline-light btn-sm mr-3"
          @click="removeAttribute(attrObj.attribute.id)"
        >
        <i class="fas fa-trash " style="color:red"></i>
          
          
        </button>    
            <strong class="mr-2">
                {{ attrObj.attribute.name }}
            </strong>

            <button 
                type="button"
                class="btn btn-light p-0 ml-2"
                @click="attrObj.attribute.isOpen = !attrObj.attribute.isOpen"
            >
                <i v-if="attrObj.attribute.isOpen" class="fa fa-minus"></i>
                <i v-else class="fa fa-plus"></i>
            </button>
            </div>
       
        
      </div>

      <!-- Modifica valori esistenti -->

  
      <div v-if="attrObj.attribute.isOpen == true" v-for="val in attrObj.attribute.values" :key="val.id" class="input-group mb-1">
        <input
          type="text"
          v-model="val.value"
          class="form-control"
        />
         <div class="input-group-append">
          <button
            class="btn btn-outline-success"
            type="button"
            
            @click="editValue(attrObj.attribute.id,val.id,val.value)"
          >
            MODIFICA VALORE
          </button>

          
        </div>
      </div>

      <!-- Aggiungi nuovo valore -->
      <div v-if="attrObj.attribute.isOpen" class="input-group mt-2">
        <input
          type="text"
          v-model="attrObj.newValueName"
          class="form-control"
          placeholder="Nuovo valore..."
          @keyup.enter="addValue(attrObj)"
        />
        <div class="input-group-append">
          <button
            class="btn btn-outline-primary"
            type="button"
            :disabled="!attrObj.newValueName"
            @click="addValue(attrObj)"
          >
            AGGIUNGI VALORE
          </button>
        </div>
      </div>

      

    </div>
    

    <productAttributes @update="setData" ref="productAttributes"  v-bind:productId="productId"></productAttributes> 

    
    <button v-if="items.length > 0" @click="saveProductAttributeValues()" class="btn btn-primary float-right mt-3 mb-3">      
                <i style="color:yellow" class="fas fa-save mr-2" aria-hidden="true"></i>
                    SALVA ATTRIBUTI PRODOTTO
    </button>

    <!-- Preview debug -->
    <pre v-if="false" class="mt-3">{{ productAttributes }}</pre>
    <pre v-if="false" >Attributi : {{ productId }}</pre>


  </div>
</template>

<script>
import api                   from "@/api"
import { mapGetters }        from 'vuex'
import productAttributes     from '@/components/product/AttributiProdotto.vue'
import modalMessage          from '@/components/modalDialog/ModalMessage.vue'      


export default {
 // props : ['productId'] ,

 inheritAttrs : false, 

  components :{productAttributes,modalMessage} ,
  data() {
    return {

      attributes                  : [],     
      selectedExistingAttributeId : "",
      newAttributeName            : "",
      productAttributes           : [],
      nextAttributeId             : 3,
      nextValueId                 : 100,
      items                       : [],
      productId                   : 0
    }
  },
   directives: 
    {
      focus: {
      // directive definition
        inserted: function (el) {
          el.focus()}
       
      }
    },
  computed: {
    availableAttributes() {

      if(this.productId > 0 && this.productAttributes.length > 0)
      {
        
        const usedIds = this.productAttributes.map(a => a.attribute.id)
        return this.attributes.filter(a => !usedIds.includes(a.id))  
      }
      
      return this.attributes

    },
    ...mapGetters(['company']) 
    },   
  created()
  {
    
     Object.keys(this.$attrs).forEach(key => {
      
      const value = this.$attrs[key];     
      if(key == 'item')
      {
        this.productId = this.checkDataType(value)
      }
      else if(key=='productId')  {
          this.productId = value
      }
      
      
      /*
      console.log(
        `Prop "${key}" =`, value,
        '| Tipo =', this.checkDataType(value)
      );
        */


    });

    //this.productId = this.checkDataType(this.data)
    
    this.getData()
  },
  methods: {
    checkDataType(value) {
      
      if (typeof value === 'object' && value !== null) return value.productId;
      return value;
    },
   async saveProductAttributeValues()
    {
        this.$refs.msgModal.show()                      
        this.$refs.msgModal.setSpinner(true,{'title':'ELABORAZIONE IN CORSO ...'})    
        const items   = this.items  
        const payload = 
        {
              sp                : 'spCreateProductAttributesValues',                  
              'productId'       : this.productId,items
        }      
        try {
                

                const res = await api.post(payload)                
                this.$refs.msgModal.setSpinner(false)    
                
                
                  if (res.status !== 200) 
                  {
                    throw new Error(res.data || res)
                  }
                  this.$refs.msgModal.setSpinner(false)    
                  this.$refs.msgModal.show('REGISTRAZIONE EFFETTUATA.',{'title':'MESSAGGIO'},4)   
                  
                  
              }       

              catch(err){
                 throw err
              }
    

    },
   
    
    setData(data)
    {
      this.items = data
      console.log(data)
    },
    async getData()
    {
        //this.bt_spinner = true
        
        this.productAttributes = []
        this.attributes        = []
        const payload          = 
        {
            'companyId'   : this.company.Id,   
            'productId'   : this.productId
        
        }
        
        const sp        = {'sp' : 'spCompanyAttributes'}
        const json      = Object.assign(payload, sp);

        await api.post(json).then(res => {
             
    
          if(res.status==200)
            {
               
               if(res.data.recordsets[0].length > 0) 
               {
                
                 this.attributes =  res.data.recordsets[0]
               
                 if(res.data.recordsets[1][0] )
                 {
                  this.productAttributes = res.data.recordsets[1][0] 

                 }
                 this.items =this.productAttributes 
                 
                 
                 
               }
                               
            }
            else if(res.status==500)
            {
              
              /*  
              this.msg.title = "ATTENZIONE " 
              this.msg.body  = res.data
              this.msg.type  = 1    
              */  
            } 
            else
            {
              /*
              this.msg.title = "ATTENZIONE " 
              this.msg.body  = res
              this.msg.type  = 1    
              */
               
            } 
        }).catch(err => 
        {
          /*
            this.msg.title = "ATTENZIONE " 
            this.msg.body  = err.message
            this.msg.type  = 1    
            */
            
        }).finally(() => {
          //this.bt_spinner = false
        });

      
    },  

    async removeProductAttribute(attributeId)
    {
        //this.bt_spinner = true
        
        const payload          = 
        {
            'attributeId' : attributeId,   
            'productId'   : this.productId
        
        }
        
        const sp        = {'sp' : 'spDeleteProductAttribute'}
        const json      = Object.assign(payload, sp);

        await api.post(json).then(res => {
             
                
          if(res.status==200)
            {
              this.getData()
              this.$refs.productAttributes.getData()                                
            }
            else if(res.status==500)
            {
              
              /*  
              this.msg.title = "ATTENZIONE " 
              this.msg.body  = res.data
              this.msg.type  = 1    
              */  
            } 
            else
            {
              /*
              this.msg.title = "ATTENZIONE " 
              this.msg.body  = res
              this.msg.type  = 1    
              */
               
            } 
        }).catch(err => 
        {
          /*
            this.msg.title = "ATTENZIONE " 
            this.msg.body  = err.message
            this.msg.type  = 1    
            */
            
        }).finally(() => {
          //this.bt_spinner = false
        });

      
    },  


    async AssociaAttributoProdotto(attributeId)
    {
        //this.bt_spinner = true
        
        
        const payload          = 
        {
        
            'productId'   : this.productId,
            'attributeId' : attributeId
        }
        
        const sp        = {'sp' : 'spInsertAssociazioneAttributoProdotto'}
        const json      = Object.assign(payload, sp);

        await api.post(json).then(res => {
             
                
          if(res.status==200)
            {
               
                this.getData()
                this.$refs.productAttributes.getData() 
                              
            }
            else if(res.status==500)
            {
              
              /*  
              this.msg.title = "ATTENZIONE " 
              this.msg.body  = res.data
              this.msg.type  = 1    
              */  
            } 
            else
            {
              /*
              this.msg.title = "ATTENZIONE " 
              this.msg.body  = res
              this.msg.type  = 1    
              */
               
            } 
        }).catch(err => 
        {
          /*
            this.msg.title = "ATTENZIONE " 
            this.msg.body  = err.message
            this.msg.type  = 1    
            */
            
        }).finally(() => {
          //this.bt_spinner = false
        });

      
    },  

async InsertAttribute(attribute)
    {
        //this.bt_spinner = true
        
        
        const payload          = 
        {                    
            'attributo'     : attribute,
            'companyId'     : this.company.Id
        }
        
        const sp        = {'sp' : 'spInsertAttributo'}
        const json      = Object.assign(payload, sp);
        
        
        await api.post(json).then(res => {
             
                
          if(res.status==200)
            {
               
                this.getData()
                this.$refs.productAttributes.getData() 
                              
            }
            else if(res.status==500)
            {
              alert('ATTENZIONE !\n' + res.data)
              console.log(res.data)
              /*  
              this.msg.title = "ATTENZIONE " 
              this.msg.body  = res.data
              this.msg.type  = 1    
              */  
            } 
            else
            {

               alert('ATTENZIONE !\n' + res)
              /*
              this.msg.title = "ATTENZIONE " 
              this.msg.body  = res
              this.msg.type  = 1    
              */
               
            } 
        }).catch(err => 
        {
           alert('ATTENZIONE !\n' + err)
          /*
            this.msg.title = "ATTENZIONE " 
            this.msg.body  = err.message
            this.msg.type  = 1    
            */
            
        }).finally(() => {
          //this.bt_spinner = false
        });

      
    },  

async InsertValoreAttributo(id,description)
    {
        //this.bt_spinner = true
        
        
        const payload          = 
        {                    
            'attributeId'     : id,
            'description'     : description
        }
        
        const sp        = {'sp' : 'spInsertValoreAttributo'}
        const json      = Object.assign(payload, sp);
        
        
        await api.post(json).then(res => {
             
                
          if(res.status==200)
            {
               
                this.getData()
                this.$refs.productAttributes.getData() 
                              
            }
            else if(res.status==500)
            {
              alert('ATTENZIONE !\n' + res.data)
              console.log(res.data)
              /*  
              this.msg.title = "ATTENZIONE " 
              this.msg.body  = res.data
              this.msg.type  = 1    
              */  
            } 
            else
            {

               alert('ATTENZIONE !\n' + res)
              /*
              this.msg.title = "ATTENZIONE " 
              this.msg.body  = res
              this.msg.type  = 1    
              */
               
            } 
        }).catch(err => 
        {
           alert('ATTENZIONE !\n' + err)
          /*
            this.msg.title = "ATTENZIONE " 
            this.msg.body  = err.message
            this.msg.type  = 1    
            */
            
        }).finally(() => {
          //this.bt_spinner = false
        });

      
    },  

async UpdateValoreAttributo(attributeId,Id,description)
    {
        //this.bt_spinner = true
        
        
        const payload          = 
        {                    
            'attributeId'     : attributeId,
            'Id'              : Id, 
            'description'     : description
        }
        
        const sp        = {'sp' : 'spUpdateValoreAttributo'}
        const json      = Object.assign(payload, sp);
        
        
        await api.post(json).then(res => {
             
                
          if(res.status==200)
            {
               
                this.getData()
                              
            }
            else if(res.status==500)
            {
              alert('ATTENZIONE !\n' + res.data)
              console.log(res.data)
              /*  
              this.msg.title = "ATTENZIONE " 
              this.msg.body  = res.data
              this.msg.type  = 1    
              */  
            } 
            else
            {

               alert('ATTENZIONE !\n' + res)
              /*
              this.msg.title = "ATTENZIONE " 
              this.msg.body  = res
              this.msg.type  = 1    
              */
               
            } 
        }).catch(err => 
        {
           alert('ATTENZIONE !\n' + err)
          /*
            this.msg.title = "ATTENZIONE " 
            this.msg.body  = err.message
            this.msg.type  = 1    
            */
            
        }).finally(() => {
          //this.bt_spinner = false
        });

      
    },  


    addExistingAttribute() {
      const attr = this.attributes.find(a => a.id === this.selectedExistingAttributeId)
      if (!attr) return
      
      /*
      this.productAttributes.push({
        attribute       : attr,
        selectedValueId : "",
        newValueName    : ""
      })
        */
      //this.selectedExistingAttributeId = ""

      this.AssociaAttributoProdotto(this.selectedExistingAttributeId)

    },

    addNewAttribute() {
      if (!this.newAttributeName) return
      console.log(this.newAttributeName)
      
      this.InsertAttribute(this.newAttributeName)
      this.newAttributeName = ""
    },

    addValue(attrObj) {
      if (!attrObj.newValueName) return
      
      this.InsertValoreAttributo(attrObj.attribute.id,attrObj.newValueName)


    },

     editValue(attributeId,id,value) {
     // if (!attrObj.newValueName) return
      //console.log(attributeId,id,value)
      this.UpdateValoreAttributo(attributeId,id,value)


    },


    removeAttribute(attributeId) {
    
       this.removeProductAttribute(attributeId)
    
    },

    submitForm() {
      // Validazione semplice
      for (const attrObj of this.productAttributes) {
        if (attrObj.attribute.values.length > 0 && !attrObj.selectedValueId) {
          alert(`Seleziona un valore per ${attrObj.attribute.name}`)
          return
        }
      }

      const payload = this.productAttributes.map(a => ({
        attributeId: a.attribute.id,
        valueId: a.selectedValueId
      }))

      console.log("Dati inviati:", payload)
      alert("Prodotto salvato! Controlla console.")
    }
  }
}
</script>
<style scoped>

h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}
</style>